<template>
	<form ref="form_aiorder_list" id="form_aiorder_list" :action="`${SERVER_URL}/api/app/aiorder`"
		@submit.prevent="form_aiorder_list_submit()" method="post" autocomplete="off">
		<input type="hidden" name="checked_id">

		<div class="subTitWrap">
			<div class="subTit">[주문 관리 목록]</div>
			<ul v-if="globaljs.acc_type === 'lab' && func_print" class="subBtn">
				<li>
					<button type="button" @click="form_aiorder_list_submit()">선택 원본출력</button>
				</li>
			</ul>
		</div>

		<table>
			<thead>
				<tr>
					<th v-if="globaljs.acc_type === 'lab' && func_print" class="chkBox"><input type="checkbox"
							@click="checkAll($event)" id="chk_all"></th>
					<th class="cols1">접수번호</th>
					<th class="cols2">주문일</th>
					<th class="cols3">차트접수일</th>
					<th class="cols4">{{ globaljs.acc_type === 'lab' ? '치과' : '기공소' }}</th>
					<th class="cols5">환자명</th>
					<th class="cols6">리메이크</th>
					<th class="cols7">치식수량</th>
					<th class="cols8">보철수량</th>
					<th class="cols9">제작상태</th>
					<th class="cols10">희망 완료일</th>
					<th class="cols11">AI 의뢰서</th>
				</tr>
			</thead>
			<tbody :class="HZwrapper">
				<tr v-if="paginatedItems.length > 0" v-for="(item, index) in paginatedItems" :key="item.id"
					class="tableItem">
					<td v-if="globaljs.acc_type === 'lab' && func_print" class="cols_chk">
						<input type="checkbox" name="chk[]" class="chk" :value="item.id"
							:disabled="!item.aiorderAiorderDoc?.[0]?.name">
					</td>
					<td class="cols1">{{ item.aiorder_no }}</td>
					<td class="cols2">{{ commonjs.isValidDateTime(orderJsonData[item.id].registerDate) ? commonjs.dateFormatYMD(orderJsonData[item.id].registerDate) : '없음' }}</td>
					<td class="cols3">{{ commonjs.isValidDateTime(orderJsonData[item.id].chartDate) ? commonjs.dateFormatYMD(orderJsonData[item.id].chartDate) : '없음' }}</td>
					<td class="cols4">{{ item.memberAiorder_Hospital ? item.memberAiorder_Hospital.mb_nick : item.memberAiorder_Lab.mb_nick }}</td>
					<td class="cols5">{{ orderJsonData[item.id].patientName }}</td>
					<td class="cols6">
						<div class="icon_remake" :class="{ 'active': item.remake_cnt > 0 }"></div>
					</td>
					<td class="cols7">{{ aiorder_teeth_count(item.id) }}</td>
					<td class="cols8">{{ validProsthesisCount(item.id) }}</td>
					<td class="cols9">
						<div v-if="item.order_status === 'ords1'" class="progress_status"
							style="background-color:#EEFFDD; color:#449f25;">의뢰서 접수</div>
						<div v-if="item.order_status === 'ords2'" class="progress_status"
							style="background-color:#E3FAF8; color:#1E8AD8;">의뢰서 확인</div>
						<div v-if="item.order_status === 'ords3'" class="progress_status"
							style="background-color:#f3f3f3; color:#666666;">출고 완료</div>
						<div v-if="item.order_status === 'ords4'" class="progress_status"
							style="background-color:#ffffff; color:#e76150;">주문 취소</div>
					</td>
					<td class="cols10">
						{{ commonjs.isValidDateTime(orderJsonData[item.id].completeHopeDate) ? commonjs.dateFormatYMD(orderJsonData[item.id].completeHopeDate) : '완료일 입력 요망' }}
						<br />
						<template v-if="commonjs.isValidDateTime(orderJsonData[item.id].completeHopeDate)">
							<b v-if="item.order_status != 'ords3' && item.order_status != 'ords4'" class="d-day"
								:class="{ 'zero': commonjs.calculateDDay(orderJsonData[item.id].completeHopeDate) }">
								{{ item.order_status === 'ords1' || item.order_status === 'ords2' ? commonjs.calculateDDay(orderJsonData[item.id].completeHopeDate) : '-' }}
							</b>
						</template>
						<template v-else>-</template>
					</td>
					<td class="cols11">
						<div class="icon_aiFile" @click="commonjs.pagePopup(`/aiorder_view/${item.id}`)"></div>
					</td>
				</tr>
				<tr v-else>
					<td colspan="12">데이터가 없습니다.</td>
				</tr>
			</tbody>
		</table>

		<div class="page">
			<ul :id="HZpaginationId" class="pagination">
				<li :class="HZpaginationArrowsClass" v-show="currentPage > 1" @click="previousPage">&lt;</li>
				<li>
					<ul class="num_wrap">
						<li v-for="page in pagesToShow" :key="page"
							:class="['paginacaoValor', HZpaginationCustomClass, { 'active': currentPage === page }, 'num']"
							@click="goToPage(page)">
							{{ page }}
						</li>
					</ul>
				</li>
				<li :class="HZpaginationArrowsClass" v-show="currentPage < totalPages" @click="nextPage">&gt;</li>
			</ul>
		</div>

	</form>
</template>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';

// Props
const props = defineProps({
	perPage: {
		type: Number,
		default: 10
	},
	func_print: {
		type: Boolean,
		default: false
	},
	searchModels: {
		type: Object,
		default: () => ({})
	}
});

let submitingFlag = false; // 플래그 변수
const withSubmitFlag = async (asyncFunc) => {
	if (submitingFlag) return; // 요청 중복 방지
		submitingFlag = true; // 요청 시작 시 플래그 설정
	try {
		await asyncFunc(); // 비동기 함수 실행
	} finally {
		submitingFlag = false; // 요청이 끝나면 플래그 해제
	}
};

const items = ref([]);
const orderJsonData = ref([]); // order_json_data

const HZwrapper = 'paginationTable';
const HZpaginationId = 'pagination-container';
const HZpaginationArrowsClass = 'paginacaoCursor';
const HZpaginationCustomClass = 'customPagination';
const currentPage = ref(1);
const totalPages = computed(() => Math.ceil(items.value.length / props.perPage));

const paginatedItems = computed(() => {
	const start = (currentPage.value - 1) * props.perPage;
	const end = start + props.perPage;
	return items.value.slice(start, end);
});

const goToPage = (page) => {
	if (page > 0 && page <= totalPages.value) {
		currentPage.value = page;
	}
};

const previousPage = () => {
	if (currentPage.value > 1) {
		currentPage.value--;
	}
};

const nextPage = () => {
	if (currentPage.value < totalPages.value) {
		currentPage.value++;
	}
};

const pagesToShow = computed(() => {
	const pages = [];
	const totalPagesValue = totalPages.value;
	const currentPageValue = currentPage.value;
	const showPagesCount = 10; // 한번에 보여줄 페이지 번호 개수
	const halfShowPagesCount = Math.floor(showPagesCount / 2);

	let start = Math.max(1, currentPageValue - halfShowPagesCount);
	let end = Math.min(totalPagesValue, currentPageValue + halfShowPagesCount);

	if (currentPageValue <= halfShowPagesCount) {
		end = Math.min(totalPagesValue, showPagesCount);
	}

	if (currentPageValue > totalPagesValue - halfShowPagesCount) {
		start = Math.max(1, totalPagesValue - showPagesCount + 1);
	}

	for (let i = start; i <= end; i++) {
		pages.push(i);
	}

	return pages;
});

const checkAll = (event) => {
	const checkboxes = document.querySelectorAll('.chk');
	checkboxes.forEach(checkbox => {
		checkbox.checked = event.target.checked;
	});
};

const aiorder_teeth_count = ((a_id) => {
	const data = orderJsonData.value[a_id];
	let count = 0;
	for (let i = 1; i <= validProsthesisCount(a_id); i++) {
		if ( typeof data[`teeth_${i}`] !== 'undefined' ) {
			count += data[`teeth_${i}`][0].split(',').length;
		}
	}
	return count;
});

const validProsthesisCount = ((a_id) => {
	const data = orderJsonData.value[a_id];
	if (!data || typeof data.prosthesis_cnt === 'undefined') {
		return 0;
	}
	const count = parseInt(data.prosthesis_cnt, 10);
	return isNaN(count) || count <= 0 ? 0 : count;
});

// 각 체크박스의 상태를 변경할 때마다 이 함수가 호출되도록 설정
function updateCheckedIds() {
	const checked_id_input = document.querySelector('input[name="checked_id"]');
	const formElement = document.getElementById('form_aiorder_list');
	
	// 체크된 체크박스의 값을 담을 배열
	const checkedValues = [];

	// 체크된 체크박스의 값을 배열에 추가
	formElement.querySelectorAll('input[type="checkbox"]').forEach((input) => {
		if (input.type === 'checkbox' && input.id !== 'chk_all' && input.checked) {
			checkedValues.push(input.value);
		}
	});

	// checked_id_input의 값을 새로 갱신
	checked_id_input.value = checkedValues.join(',');
}

onMounted(async () => {
	await getModels();
});

const getModels = async () => {
	const params = new URLSearchParams();
	params.append('mb_boss_id', globaljs.mb_boss_id);
	params.append('acc_type', globaljs.acc_type);
	//params.append('mb_level', globaljs.mb_level);
	params.append('orderBy', 'id'); // 정렬필드
	params.append('align', 'desc'); // 정렬순서

	// order.vue에서 보낸 검색어 추가
	if (props.searchModels) {
		Object.keys(props.searchModels).forEach(key => {
			params.append(key, props.searchModels[key]);
		});
	}

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/aiorder`, { params });
console.debug(response.data.result);
		items.value = response.data.result;
		currentPage.value = 1; // 240822 1페이지로 고정
		for (let i = 0; i < items.value.length; i++) {
			// 241022 파싱할때 특수문자 오류. sanitizeJSONString함수 추가.
			const sanitizedData = commonjs.sanitizeJSONString(items.value[i].order_json_data);
			orderJsonData.value[items.value[i].id] = JSON.parse(sanitizedData);
		}
console.debug(orderJsonData.value);
	} catch (error) {
console.error('Error getModels:', error);
	}
}

// 메서드 노출 설정
defineExpose({
	getModels
});

// 검색어가 변경될 때마다 데이터를 다시 조회
//watch(() => props.searchModels, getModels, { deep: true });

async function form_aiorder_list_submit() {
	await withSubmitFlag(async () => {
		const enabledInputs = document.querySelectorAll("input[type='checkbox'].chk:checked");
		// enabledInputs의 길이를 카운팅합니다.
		const count = enabledInputs.length;
		if (count < 1) {
			commonjs.formSwal('필수 선택', '원본을 출력할 항목을 의뢰서를 하나 이상 선택해주세요.', '#chk_all', 'self');
			return false;
		}

		const formElement = document.getElementById('form_aiorder_list');
		const essentials = formElement.querySelectorAll('[required]');
		for (const element of essentials) {
			if (!element.value || element.value.trim() === '' || element.value.trim().length < 1) {
				const label = formElement.querySelector(`label[for="${element.id}"]`);
				const fieldName = label ? label.textContent.replace(':', '') : element.name;
				commonjs.formSwal(`필수 입력`, `[${fieldName}]은 필수 입력 항목입니다.`, `#${element.id}`, 'self');
				return false;
			}

			// input type="date"의 경우 날짜 형식 검증
			if (element.type === 'date' && !commonjs.isValidDate(element.value)) {
				const label = formElement.querySelector(`label[for="${element.id}"]`);
				const fieldName = label ? label.textContent.replace(':', '') : element.name;
				commonjs.formSwal(`날짜 형식 오류`, `[${fieldName}]의 날짜 형식이 올바르지 않습니다.`, `#${element.id}`, 'self');
				return false;
			}
		}

		/*
		formElement.querySelectorAll('input').forEach((input) => {
			if (input.type === 'checkbox' && input.id !== 'chk_all' && input.name !== "") {
				if (input.checked && !input.disabled) {
					if (checked_id_input.value === '') {
						checked_id_input.value = input.value;
					} else {
						checked_id_input.value += ',' + input.value;
					}
				}
			}
		});
		*/

		updateCheckedIds();

		const checked_id_input = document.querySelector('input[name="checked_id"]');

		try {
			commonjs.chargePopup(`/print_imgs/${checked_id_input.value}`);
		} catch (error) {
			console.error(error?.response?.data);
			commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
		}
	});
}
</script>